import { Component, OnInit } from "@angular/core";
import { MasterService } from "../services/master.service";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-not-allowed',
  templateUrl: './notAllowed.component.html',
  styleUrls: ['./notAllowed.component.scss']
})
export class NotAllowedComponent implements OnInit {
    constructor(private masterService: MasterService) {}

    ngOnInit(): void {
        console.log("Not Allowed Component Loaded");
        this.masterService.getIpAddress()
        .subscribe((res: any) => {
          const ip = res.ip;

            if (environment.allowedIPs.includes(ip)) {
                window.location.href = '/login';
            } else {
                console.log("Access denied for IP:", ip);
            }
        });
    }

};